module.exports = __webpack_public_path__ + "img/knsu_gallery1.fbfa1c9b.jpg";